<w-page icon="fa-regular fa-triangle-exclamation" title="New Defect" mode="Modal" [hideClose]="false" (close)="onCancel()">

  <ng-container *w-page-body-content>
    <defect-creator [defect]="draft" [dateFormat]="data?.dateFormat" [timezone]="data?.timezone"></defect-creator>
  </ng-container>

  <ng-container *w-page-footer-right-actions>
    <w-button displayStyle="Tertiary" size="Medium" label="Cancel" (onClick)="onCancel()" />
    <w-button displayStyle="Primary" size="Medium" label="Save" [disabled]="$creator()?.form?.invalid || $saving()" (onClick)="onSave()" />
  </ng-container>

</w-page>
